(function () {
  if (window.__ccDeliveryModule) return;
  window.__ccDeliveryModule = true;

  /* Awaryjna lista. Prawdziwe ID czytamy z DOM — patrz sectionIds(). */
  var SECTION_FALLBACK = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'];
  var SECTION_HOSTS = ['cart-items', 'cart-drawer', 'cart-drawer-items', '.cart__footer', '.cart__items'];
  var CHECKOUT = ['#checkout', '#CartDrawer-Checkout', 'button[name="checkout"]', 'input[name="checkout"]'];
  var EXPRESS = ['.cart__dynamic-checkout-buttons', '#dynamic-checkout-cart', '[data-shopify="dynamic-checkout-cart"]', '.additional-checkout-buttons', 'shopify-accelerated-checkout', 'shopify-accelerated-checkout-cart'];
  var MOUNTS = ['cart-drawer-items', '#CartDrawer .drawer__footer', 'cart-drawer .drawer__footer', '.drawer__footer'];

  var A_STATE = '_cc_state';
  var A_OUT = 'Delivery';
  var A_BACK = 'Collection';
  var A_PHONE = 'Phone';

  var PC_API = 'https://api.postcodes.io/postcodes/';
  var HOME_DISTRICT = 'City of Edinburgh';
  var MONTHS = { january:1, february:2, march:3, april:4, may:5, june:6,
                 july:7, august:8, september:9, october:10, november:11, december:12 };
  var pcCache = {};

  var conf = null;
  function blank(mode) { return { m: mode, a: '', x: '', c: 'Edinburgh', p: '', t: '', fl: '', air: false, zone: null, check: { state: 'idle' } }; }
  var S = { o: blank('deliver'), b: blank('collect'), same: true, goods: true, lastMinute: false, synced: true, phone: '' };
  var repairs = 0;
  var busy = false;
  var typing = null;
  var booted = false;

  function log() { if (window.__ccDebug) console.log.apply(console, ['[cc-dm]'].concat([].slice.call(arguments))); }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function readConf() {
    if (conf) return conf;
    var el = document.querySelector('[data-cc-conf]');
    if (!el) return null;
    try { conf = JSON.parse(el.textContent); } catch (e) { conf = null; }
    return conf;
  }

  function money(p) { var n = p / 100; return '£' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  function norm(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function pretty(s) { var n = norm(s); return n.length < 5 ? n : n.slice(0, n.length - 3) + ' ' + n.slice(n.length - 3); }

  /* ---------- sanityzacja tekstu od klienta ----------
     Liquid NIE escape'uje. W sections/main-cart-items.liquid wlasciwosc linii
     leci przez {{ property.last }} SUROWO, wiec HTML wpisany w pole adresu
     wyrenderowalby sie w mailu i na packing slipie — czyli u Patrycji.
     To nie jest przejecie konta (admin Shopify escape'uje), ale pozwala rozwalic
     uklad wiadomosci albo wstawic mylacy odnosnik.
     Czyscimy wlasnie TUTAJ, bo przez trim() przechodzi wszystko, co opuszcza
     modul: oneLine, airLine, airProps i packLeg. Jedno miejsce zamiast pieciu. */
  var MAXLEN = 120;
  function trim(s) {
    return String(s == null ? '' : s)
      .replace(/[<>]/g, '')
      .replace(/[\u0000-\u001F\u007F]/g, ' ')
      .trim()
      .slice(0, MAXLEN);
  }

  function zoneOf(raw) {
    var c = readConf();
    if (!c) return null;
    var n = norm(raw);
    if (n.length < 5 || n.length > 7) return null;
    var key = c.exact[n] || c.outward[n.slice(0, n.length - 3)] || null;
    /* Strefa bez kompletu produktow (np. ktos skasowal produkt dostawy) zachowuje
       sie jak strefa poza zasiegiem: klient dostaje przycisk na darmowy odbior,
       a nie zepsuty koszyk. To jest to "wylaczaj opcje, nie caly modul". */
    if (!key || !c.zones[key]) return null;
    return key;
  }

  /* ---------- ID sekcji do przerysowania ----------
     Dwie pulapki naraz, obie potwierdzone w dokumentacji Shopify.

     1) API przyjmuje ID SEKCJI, nie jej typ. W templates/cart.json sekcje
        nazywaja sie 'cart-items' i 'cart-footer', nie 'main-cart-items' /
        'main-cart-footer'. Zle ID nie powoduje bledu — wraca null w poprawnej
        odpowiedzi 200, wiec objaw jest cichy i mylacy.
     2) "Requesting more than five sections returns 400 Bad Request and renders
        nothing." Przekroczenie piatki nie psuje jednej sekcji — kasuje CALA
        odpowiedz. Dlatego NIE WOLNO dopychac listy awaryjnymi nazwami
        "na wszelki wypadek" i trzeba twardo ciac do pieciu.

     Najpewniejsze zrodlo to data-id, ktore Dawn wypisuje na #main-cart-items
     i #main-cart-footer — z tego samego korzysta cart.js Dawna.
     Sekcji modulu ('ccdelivery') tu NIE ma i byc nie moze: przerysowanie jej
     skasowaloby pola, w ktorych klient wlasnie pisze. */
  function sectionIds() {
    var seen = {};
    function add(id) { if (id) seen[id] = true; }

    ['main-cart-items', 'main-cart-footer'].forEach(function (k) {
      var el = document.getElementById(k);
      if (el && el.dataset && el.dataset.id) add(el.dataset.id);
    });

    SECTION_HOSTS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var sec = el.closest ? el.closest('[id^="shopify-section-"]') : null;
        if (sec) add(sec.id.replace('shopify-section-', ''));
      });
    });

    add('cart-icon-bubble');

    var ids = Object.keys(seen);
    if (!ids.length) ids = SECTION_FALLBACK.slice();
    return ids.slice(0, 5);
  }

  function panels() { return document.querySelectorAll('[data-cc-dm]:not([data-cc-where="drawer"])'); }
  function template() { return document.querySelector('[data-cc-dm][data-cc-where="drawer"]'); }

  function ourIds() {
    var c = readConf();
    if (!c) return [];
    var ids = [];
    Object.keys(c.zones).forEach(function (k) {
      if (c.zones[k] && c.zones[k].out) ids.push(String(c.zones[k].out.id));
      if (c.zones[k] && c.zones[k].back) ids.push(String(c.zones[k].back.id));
    });
    if (c.free && c.free.out) ids.push(String(c.free.out.id));
    if (c.free && c.free.back) ids.push(String(c.free.back.id));
    if (c.lastminute) ids.push(String(c.lastminute.id));
    return ids;
  }

  /* ---------- weryfikacja kodu pocztowego (postcodes.io, darmowe, bez klucza) ----------
     Zasada nadrzedna: NIGDY nie blokujemy sprzedazy z powodu awarii cudzego API.
     Stan 'error' (brak sieci, 500, timeout) jest traktowany jak poprawny. Blokujemy
     wylacznie wtedy, gdy API wyraznie powie, ze kod nie istnieje albo lezy poza
     Edynburgiem — i zawsze dajemy wtedy wyjscie na darmowy odbior. */

  function lookup(leg) {
    var raw = norm(leg.p);
    if (raw.length < 5) { leg.check = { state: 'idle' }; return; }
    if (pcCache[raw]) { leg.check = pcCache[raw]; paint(); return; }

    leg.check = { state: 'checking' };
    paint();

    fetch(PC_API + encodeURIComponent(raw))
      .then(function (r) { return r.json().then(function (j) { return { http: r.status, j: j }; }); })
      .then(function (res) {
        var out;
        if (res.http === 404) out = { state: 'notfound' };
        else if (res.j && res.j.result) {
          var d = res.j.result.admin_district || '';
          out = d === HOME_DISTRICT
            ? { state: 'ok', district: d, ward: res.j.result.admin_ward || '' }
            : { state: 'outside', district: d };
        } else out = { state: 'error' };
        pcCache[raw] = out;
        if (norm(leg.p) === raw) { leg.check = out; paint(); }
      })
      .catch(function () {
        if (norm(leg.p) === raw) { leg.check = { state: 'error' }; paint(); }
      });
  }

  function checkState(leg) { return (leg.check && leg.check.state) || 'idle'; }

  /* Kazda noga ma WLASNY produkt: osobny dla dowozu, osobny dla odbioru.
     Dzieki temu klient widzi w koszyku dwie nazwane pozycje zamiast jednej
     w ilosci 2, a Patrycja moze wycenic obie nogi niezaleznie. */
  function legProduct(group, zoneKey) {
    var c = readConf();
    if (!c || !zoneKey || !c.zones[zoneKey]) return null;
    return c.zones[zoneKey][group === 'o' ? 'out' : 'back'] || null;
  }
  function freeProduct(group) {
    var c = readConf();
    if (!c || !c.free) return null;
    return c.free[group === 'o' ? 'out' : 'back'] || null;
  }
  /* Lotnisko jest OPCJA, nie wynikiem kodu pocztowego — prawie nikt nie zna
     EH12 9DN. Istnieje tylko wtedy, gdy strefa ma komplet produktow; inaczej
     checkbox sie nie pokazuje (wylaczamy opcje, nie caly modul). */
  function airportZone() {
    var c = readConf();
    return (c && c.zones && c.zones.airport) ? 'airport' : null;
  }
  function backMode() { return S.same ? (S.o.m === 'self' ? 'self' : 'collect') : S.b.m; }
  function backZone() { return S.same ? S.o.zone : S.b.zone; }

  function legOk(leg, group) {
    if (leg.m === 'self') return !!freeProduct(group || 'o');
    if (!leg.zone) return false;
    if (!legProduct(group || 'o', leg.zone)) return false;
    /* Lotnisko: bez adresu i bez kodu pocztowego. Godzina jest OBOWIAZKOWA, bo
       bez niej Patrycja nie wie, kiedy tam byc. Numer lotu zostaje opcjonalny —
       pomaga przy opoznieniu, ale nie blokuje sprzedazy. */
    if (leg.air) return trim(leg.t).length > 0;
    if (trim(leg.a).length < 3) return false;
    var st = checkState(leg);
    return st !== 'checking' && st !== 'notfound' && st !== 'outside';
  }

  /* ---------- oplata last-minute ----------
     IzyRent zapisuje date jako wlasciwosc linii o kluczu 'Date' i wartosci
     "October 2, 2026 to October 6, 2026" — sprawdzone na prawdziwych zamowieniach.
     Porownujemy ze "dzis" w strefie sklepu (Europe/London), a nie w strefie
     urzadzenia klienta, bo to czesto turysta w innej strefie czasowej. */

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function parseStart(v) {
    var m = String(v || '').match(/([A-Za-z]+)\s+(\d{1,2}),\s*(\d{4})/);
    if (!m) return null;
    var mo = MONTHS[m[1].toLowerCase()];
    if (!mo) return null;
    return m[3] + '-' + pad2(mo) + '-' + pad2(parseInt(m[2], 10));
  }

  function londonToday() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function daysBetween(a, b) {
    function ms(x) { return Date.UTC(+x.slice(0, 4), +x.slice(5, 7) - 1, +x.slice(8, 10)); }
    return Math.round((ms(a) - ms(b)) / 86400000);
  }

  /* Okno last-minute ustawia Patrycja sama, metafieldem sklepu
     cobble.last_minute_days: 0 = tylko dzis, 1 = dzis albo jutro, itd.
     IzyRent zapisuje sama date bez godziny, wiec regula moze byc wyrazona
     tylko w dniach — godzinowej nie da sie zrobic na tych danych. */
  function lastMinuteDue(items) {
    var c = readConf();
    if (!c || !c.lastminute) return false;
    var days = typeof c.lastMinuteDays === 'number' ? c.lastMinuteDays : 0;
    var mine = ourIds();
    var today = londonToday();
    return items.some(function (i) {
      if (mine.indexOf(String(i.variant_id)) !== -1) return false;
      var props = i.properties || {};
      return Object.keys(props).some(function (k) {
        if (!/date/i.test(k)) return false;
        var d = parseStart(props[k]);
        if (!d) return false;
        var diff = daysBetween(d, today);
        return diff >= 0 && diff <= days;
      });
    });
  }
  function outOk() { return legOk(S.o, 'o'); }
  function backAir() { return S.same ? !!S.o.air : !!S.b.air; }
  /* Przy "return to the same place" i lotnisku wciaz potrzebujemy DRUGIEJ godziny:
     innej na przylot, innej na wylot. Samo "to samo miejsce" nie wystarcza. */
  function backOk() {
    if (!S.same) return legOk(S.b, 'b');
    if (!outOk()) return false;
    if (backMode() === 'collect' && backAir() && !trim(S.b.t)) return false;
    return true;
  }
  /* Telefon jest WSPOLNY dla calego zamowienia, nie per noga — to numer klienta,
     a nie adresu. Walidacja celowo luzna: liczymy same cyfry i wymagamy co najmniej
     siedmiu. Numery miedzynarodowe maja za duzo wariantow formatowania, zeby
     trzymac je wzorcem, a zbyt ostra regula zablokowalaby prawdziwego klienta. */
  function phoneOk() { return trim(S.phone).replace(/[^0-9]/g, '').length >= 7; }
  function allOk() { return S.goods === false ? true : (phoneOk() && outOk() && backOk()); }

  function oneLine(leg) {
    var bits = [trim(leg.a)];
    if (trim(leg.x)) bits.push(trim(leg.x));
    if (trim(leg.c)) bits.push(trim(leg.c));
    var s = bits.join(', ');
    if (leg.p) s += ' ' + pretty(leg.p);
    return s;
  }

  function airLine(leg) {
    var s = 'Edinburgh Airport';
    if (trim(leg.t)) s += ', ' + trim(leg.t);
    if (trim(leg.fl)) s += ', flight ' + trim(leg.fl);
    return s;
  }

  /* Pusty numer lotu NIE trafia do wlasciwosci linii: sameProps porownuje liczbe
     kluczy, wiec puste pole kazaloby przepisywac linie w nieskonczonosc. */
  function airProps(leg, word) {
    var o = { 'Where': 'Edinburgh Airport' };
    o[word + ' time'] = trim(leg.t);
    if (trim(leg.fl)) o['Flight'] = trim(leg.fl);
    return o;
  }

  /* ---------- rendering ---------- */

  function setTabs(p, group, value) {
    p.querySelectorAll('[data-cc-tab="' + group + '"]').forEach(function (btn) {
      var on = btn.getAttribute('data-cc-val') === value;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    p.querySelectorAll('[data-cc-pane="' + group + '"]').forEach(function (pane) {
      if (pane.getAttribute('data-cc-val') === value) pane.removeAttribute('hidden');
      else pane.setAttribute('hidden', '');
    });
  }

  function paintLeg(p, group, leg, verb) {
    var c = readConf();
    setTabs(p, group, leg.m);

    /* querySelectorAll, nie querySelector: pole godziny nogi powrotnej jest w
       DWOCH miejscach (sekcja Collection i blok "same place"), a oba musza
       pokazywac te sama wartosc. */
    ['a', 'x', 'c', 'p', 't', 'fl'].forEach(function (k) {
      p.querySelectorAll('[data-cc-f="' + group + ':' + k + '"]').forEach(function (el) {
        if (document.activeElement === el) return;
        el.value = k === 'p' ? pretty(leg.p) : leg[k];
      });
    });

    var airOn = !!leg.air;
    var airRow = p.querySelector('[data-cc-airrow="' + group + '"]');
    if (airRow) { if (airportZone()) airRow.removeAttribute('hidden'); else airRow.setAttribute('hidden', ''); }
    var airBox = p.querySelector('[data-cc-air="' + group + '"]');
    if (airBox) airBox.checked = airOn;
    var wrap = p.querySelector('[data-cc-addrwrap="' + group + '"]');
    if (wrap) { if (airOn) wrap.setAttribute('hidden', ''); else wrap.removeAttribute('hidden'); }
    var airFields = p.querySelector('[data-cc-airfields="' + group + '"]');
    if (airFields) { if (airOn) airFields.removeAttribute('hidden'); else airFields.setAttribute('hidden', ''); }

    var zl = p.querySelector('[data-cc-zone="' + group + '"]');
    var esc = p.querySelector('[data-cc-escape="' + group + '"]');
    var st = checkState(leg);
    var showEscape = false;

    if (zl && airOn) {
      zl.textContent = ''; zl.removeAttribute('data-state');
    } else if (zl) {
      if (!leg.p) {
        zl.textContent = ''; zl.removeAttribute('data-state');
      } else if (st === 'checking') {
        zl.textContent = 'Checking that postcode…'; zl.setAttribute('data-state', 'wait');
      } else if (st === 'notfound') {
        zl.textContent = 'We can’t find that postcode — please check it.';
        zl.setAttribute('data-state', 'bad');
        showEscape = true;
      } else if (st === 'outside') {
        zl.textContent = 'That looks like ' + (leg.check.district || 'somewhere outside Edinburgh') +
          '. We only ' + verb + ' inside Edinburgh — but you can still hire from us.';
        zl.setAttribute('data-state', 'bad');
        showEscape = true;
      } else if (leg.zone) {
        var ward = leg.check && leg.check.ward ? ' (' + leg.check.ward + ')' : '';
        zl.textContent = 'That is ' + c.zones[leg.zone].label + ward + '.';
        zl.setAttribute('data-state', 'ok');
      } else {
        zl.textContent = 'We don’t ' + verb + ' to that part of Edinburgh as standard — but you can still hire from us.';
        zl.setAttribute('data-state', 'bad');
        showEscape = true;
      }
    }

    if (esc) { if (showEscape) esc.removeAttribute('hidden'); else esc.setAttribute('hidden', ''); }

    var prod = legProduct(group, leg.zone);
    var row = p.querySelector('[data-cc-row="' + group + '"]');
    var pr = p.querySelector('[data-cc-price="' + group + '"]');
    var rn = p.querySelector('[data-cc-rowname="' + group + '"]');
    if (rn) {
      if (group === 'o') rn.textContent = airOn ? 'Delivery to Edinburgh Airport' : 'Delivery to that address';
      else rn.textContent = airOn ? 'Collection from Edinburgh Airport' : 'Collection from that address';
    }
    if (row) { if (prod) row.removeAttribute('hidden'); else row.setAttribute('hidden', ''); }
    if (pr && prod) pr.textContent = '+' + money(prod.price);
  }

  function paint() {
    var c = readConf();
    if (!c) return;

    panels().forEach(function (p) {
      if (S.goods === false) { p.setAttribute('hidden', ''); return; }
      p.removeAttribute('hidden');

      paintLeg(p, 'o', S.o, 'deliver');

      var ph = p.querySelector('[data-cc-phone]');
      if (ph && document.activeElement !== ph) ph.value = S.phone;

      var sw = p.querySelector('[data-cc-same]');
      if (sw) sw.checked = S.same;

      /* Noga powrotna jest widoczna OD RAZU, z wlaczonym "Return to the same
         place". Szczegoly odbioru pojawiaja sie dopiero, gdy adres dostawy jest
         kompletny i klient odznaczy toggle. Dzieki temu od pierwszej sekundy
         widac, ze sa dwie nogi i ze da sie je rozdzielic. */
      var ret = p.querySelector('[data-cc-return]');
      if (ret) ret.removeAttribute('hidden');

      var samePrice = p.querySelector('[data-cc-sameprice]');
      if (samePrice) {
        var bp = S.same ? legProduct('b', backZone()) : null;
        if (S.same && backMode() === 'self') samePrice.textContent = 'Free';
        else if (bp) samePrice.textContent = '+' + money(bp.price);
        else samePrice.textContent = '';
      }

      var block = p.querySelector('[data-cc-collection]');
      if (block) { if (!S.same && outOk()) block.removeAttribute('hidden'); else block.setAttribute('hidden', ''); }

      var waitHint = p.querySelector('[data-cc-waitaddress]');
      if (waitHint) { if (!S.same && !outOk()) waitHint.removeAttribute('hidden'); else waitHint.setAttribute('hidden', ''); }

      /* Lot powrotny ma inna godzine niz przylot, wiec nawet przy wlaczonym
         "same place" musimy o nia zapytac. */
      var airBack = p.querySelector('[data-cc-airback]');
      if (airBack) {
        if (S.same && backMode() === 'collect' && backAir()) airBack.removeAttribute('hidden');
        else airBack.setAttribute('hidden', '');
      }

      paintLeg(p, 'b', S.b, 'collect from');

      var lm = p.querySelector('[data-cc-lastminute]');
      if (lm) {
        if (c.lastminute && S.lastMinute) {
          lm.removeAttribute('hidden');
          var lmp = lm.querySelector('[data-cc-lmprice]');
          if (lmp) lmp.textContent = '+' + money(c.lastminute.price);
        } else lm.setAttribute('hidden', '');
      }

      var note = p.querySelector('[data-cc-note]');
      if (note) {
        if (S.synced === false) {
          note.textContent = 'Delivery is part of every booking — we’ve put it back in your basket.';
        } else if (!outOk()) {
          if (S.o.air && !trim(S.o.t)) note.textContent = 'Please tell us what time you land.';
          else if (S.o.zone && trim(S.o.a).length < 3) note.textContent = 'Please add the address we should deliver to.';
          else note.textContent = '';
        } else if (!backOk()) {
          if (backAir() && !trim(S.b.t)) note.textContent = 'Please tell us what time you fly out, so we know when to meet you.';
          else if (S.b.zone && trim(S.b.a).length < 3) note.textContent = 'Please add the address we should collect from.';
          else note.textContent = 'Tell us where we should pick the equipment up.';
        } else if (!phoneOk()) {
          note.textContent = 'Please add a mobile number so we can confirm your booking.';
        } else note.textContent = '';
      }
    });

    gate();
  }

  /* ---------- blokada recznej edycji naszych linii ----------
     Linie uslugowe sa WYLICZANE ze stanu modulu, wiec nie wolno ich edytowac
     recznie w koszyku. Samonaprawa i tak przywroci ilosc 1 i zablokuje checkout,
     ale zanim zdazy, klient widzi u siebie 50 GBP za dowoz i nie rozumie skoku.
     Dlatego chowamy stepper. To warstwa wierzchnia NA samonaprawie, nie zamiast
     niej — uparty klient wciaz moze strzelic w /cart/change.js.
     Hook: Dawn wypisuje data-quantity-variant-id na .quantity__input.
     Klasa ginie po kazdym przerysowaniu sekcji, dlatego nakladamy ja z gate(),
     ktore chodzi po kazdym paint, swap i w interwale. */
  function lockLines() {
    var mine = ourIds();
    if (!mine.length) return;
    document.querySelectorAll('.quantity__input[data-quantity-variant-id]').forEach(function (inp) {
      var row = inp.closest ? inp.closest('.cart-item') : null;
      if (!row) return;
      var vid = String(inp.getAttribute('data-quantity-variant-id'));
      if (mine.indexOf(vid) !== -1) row.classList.add('cc-locked');
      else row.classList.remove('cc-locked');
    });
  }

  function gate() {
    if (!document.querySelector('[data-cc-dm]')) return;
    lockLines();
    var ok = allOk() && S.synced !== false;
    CHECKOUT.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (b) { b.disabled = !ok; });
    });
    EXPRESS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) { n.style.display = ok ? '' : 'none'; });
    });
  }

  /* ---------- cart <-> state ---------- */

  function packLeg(leg) { return { m: leg.m, a: trim(leg.a), x: trim(leg.x), c: trim(leg.c), p: pretty(leg.p), t: trim(leg.t), fl: trim(leg.fl), air: leg.air ? 1 : 0 }; }

  function serialise() {
    return JSON.stringify({ v: 1, s: S.same ? 1 : 0, ph: trim(S.phone), o: packLeg(S.o), b: packLeg(S.b) });
  }

  function unpackLeg(d, fallbackMode) {
    var leg = blank(fallbackMode);
    if (!d || typeof d !== 'object') return leg;
    leg.m = d.m === 'self' ? 'self' : fallbackMode;
    leg.a = d.a || '';
    leg.x = d.x || '';
    leg.c = typeof d.c === 'string' ? d.c : 'Edinburgh';
    leg.p = d.p || '';
    leg.t = d.t || '';
    leg.fl = d.fl || '';
    leg.air = d.air === 1 || d.air === true;
    leg.zone = leg.air ? airportZone() : (leg.p ? zoneOf(leg.p) : null);
    return leg;
  }

  function restore(raw) {
    if (!raw) return false;
    var d;
    try { d = JSON.parse(raw); } catch (e) { return false; }
    if (!d || typeof d !== 'object') return false;
    S.o = unpackLeg(d.o, 'deliver');
    S.b = unpackLeg(d.b, 'collect');
    S.same = d.s !== 0;
    S.phone = d.ph || '';
    return true;
  }

  function humanOut() {
    var c = readConf();
    if (S.o.m === 'self') return 'Customer picks up from Leith Walk (free)';
    var prod = legProduct('o', S.o.zone);
    if (!prod) return '';
    if (S.o.air) return 'We meet you at ' + airLine(S.o) + ' (' + money(prod.price) + ')';
    return 'We deliver to ' + oneLine(S.o) + ' — ' + c.zones[S.o.zone].label + ' (' + money(prod.price) + ')';
  }

  function humanBack() {
    var c = readConf();
    if (backMode() === 'self') return 'Customer drops it back to Leith Walk (free)';
    var z = backZone();
    var prod = legProduct('b', z);
    if (!prod) return '';
    if (backAir()) return 'We collect you at ' + airLine(S.b) + ' (' + money(prod.price) + ')';
    if (S.same) return 'We collect from the same address — ' + oneLine(S.o) + ' (' + money(prod.price) + ')';
    return 'We collect from ' + oneLine(S.b) + ' — ' + c.zones[z].label + ' (' + money(prod.price) + ')';
  }

  function desired() {
    var c = readConf();
    var out = { updates: {}, attributes: {} };
    ourIds().forEach(function (id) { out.updates[id] = 0; });

    function want(prod) { if (prod) out.updates[String(prod.id)] = 1; }

    if (S.goods !== false) {
      if (S.o.m === 'self') want(freeProduct('o'));
      else if (S.o.zone) want(legProduct('o', S.o.zone));

      if (backMode() === 'self') want(freeProduct('b'));
      else if (backZone()) want(legProduct('b', backZone()));
    }

    if (c.lastminute) {
      out.updates[String(c.lastminute.id)] = (S.goods !== false && S.lastMinute) ? 1 : 0;
    }

    out.attributes[A_STATE] = S.goods === false ? '' : serialise();
    out.attributes[A_OUT] = S.goods === false ? '' : humanOut();
    out.attributes[A_BACK] = S.goods === false ? '' : humanBack();
    out.attributes[A_PHONE] = S.goods === false ? '' : trim(S.phone);
    return out;
  }

  /* ---------- adres jako wlasciwosc linii ----------
     Po wylaczeniu wysylki zamowienie NIE MA juz pola shipping address — ani w
     mailu, ani na packing slipie. Adres zyje wylacznie w naszych danych.
     Atrybuty koszyka widac w panelu, ale nie mialem pewnosci, czy szablony
     powiadomien je czytaja — a to zbyt wazna rzecz, zeby opierac ja na
     przypuszczeniu. Dlatego adres wpisujemy DODATKOWO jako wlasciwosc linii:
     wlasciwosci renderuja sie w domyslnym mailu, w powiadomieniu dla obslugi,
     w panelu i na packing slipie, bez edycji szablonow. Adres trafia na te
     linie, ktorej dotyczy. */

  /* Telefon dopisujemy do OBU linii, zeby byl na packing slipie obok adresu,
     ktorego akurat dotyczy przejazd. Pusty nie trafia nigdzie — sameProps
     porownuje liczbe kluczy i puste pole kazaloby przepisywac linie bez konca. */
  function withPhone(o) {
    var ph = trim(S.phone);
    if (ph) o['Phone'] = ph;
    return o;
  }

  function desiredProps() {
    var map = {};
    if (S.goods === false) return map;

    if (S.o.m === 'deliver' && S.o.zone) {
      var po = legProduct('o', S.o.zone);
      if (po) map[String(po.id)] = withPhone(S.o.air ? airProps(S.o, 'Arrival') : { 'Address': oneLine(S.o) });
    }
    if (backMode() === 'collect' && backZone()) {
      var pb = legProduct('b', backZone());
      if (pb) map[String(pb.id)] = withPhone(backAir() ? airProps(S.b, 'Collection') : { 'Address': oneLine(S.same ? S.o : S.b) });
    }
    return map;
  }

  function sameProps(a, b) {
    a = a || {}; b = b || {};
    var ka = Object.keys(a), kb = Object.keys(b);
    if (ka.length !== kb.length) return false;
    return ka.every(function (k) { return String(a[k]) === String(b[k]); });
  }

  /* Zmiana wlasciwosci tworzy nowy klucz linii, wiec ruszamy ja tylko wtedy, gdy
     faktycznie sie rozni — inaczej kazde nacisniecie klawisza przebudowywaloby
     koszyk. Ilosci zostaja bez zmian, wiec samonaprawa tego nie zauwaza. */
  function syncProps() {
    var want = desiredProps();
    if (!Object.keys(want).length) return Promise.resolve();
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var jobs = [];
        (cart.items || []).forEach(function (i) {
          var w = want[String(i.variant_id)];
          if (!w || sameProps(i.properties, w)) return;
          jobs.push(function () {
            return fetch(root() + 'cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: i.key, quantity: i.quantity, properties: w })
            });
          });
        });
        return jobs.reduce(function (p, j) { return p.then(j); }, Promise.resolve());
      })
      .catch(function () {});
  }

  /* ---------- samonaprawa koszyka ----------
     Klient moze usunac linie oplaty koszykiem (kosz przy pozycji) albo zmienic
     jej ilosc. Bez tego wychodzil z koszykiem bez dostawy i otwartym checkoutem
     — sprawdzone, dzialalo. Dlatego po KAZDYM odczycie porownujemy linie z tym,
     co wynika ze stanu, i jesli sie rozjechaly: blokujemy checkout i dokladamy
     brakujace z powrotem. Licznik 'repairs' chroni przed petla, gdyby zapis
     uporczywie nie przechodzil. */

  function linesMatch(cart) {
    var want = desired().updates;
    var have = {};
    (cart.items || []).forEach(function (i) { have[String(i.variant_id)] = i.quantity; });
    return Object.keys(want).every(function (id) { return (have[id] || 0) === want[id]; });
  }

  function fromCart(cart) {
    var c = readConf();
    if (!c) return;
    var a = cart.attributes || {};
    var mine = ourIds();
    var items = cart.items || [];

    /* "goods" = rzeczy, ktore wozi Patrycja. Pozycja z requires_shipping:true to
       paczka kurierska — nia zajmuje sie Shopify i nasz modul ma ja ignorowac.
       Dzieki temu koszyk z samymi paczkami w ogole nie pokazuje modulu i nie
       blokuje checkoutu (klient z Glasgow kupujacy samo przescieradlo).
       Czytamy to wprost z /cart.js, bez tagow — to dokladnie ta sama flaga,
       ktora decyduje o zachowaniu Shopify. Dzis zadnego produktu to nie dotyczy. */
    S.goods = items.some(function (i) {
      return mine.indexOf(String(i.variant_id)) === -1 && i.requires_shipping !== true;
    });
    S.lastMinute = S.goods ? lastMinuteDue(items) : false;

    if (!booted) {
      restore(a[A_STATE]);
      booted = true;
      if (S.o.p) lookup(S.o);
      if (S.b.p) lookup(S.b);
    }

    if (S.goods === false && items.length > 0) {
      S.o = blank('deliver'); S.b = blank('collect'); S.same = true;
      S.synced = true;
      setTimeout(function () { push(0); }, 0);
      return;
    }

    S.synced = linesMatch(cart);
    if (!S.synced && S.goods && !busy && repairs < 3) {
      repairs += 1;
      setTimeout(function () { push(0); }, 0);
    } else if (S.synced) {
      repairs = 0;
    }
  }

  function load(force) {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (!busy || force) { fromCart(cart); paint(); } return cart; })
      .catch(function () {});
  }

  function setBusy(on) {
    busy = on;
    panels().forEach(function (p) { p.classList.toggle('cc-dm--busy', on); });
  }

  function push(attempt) {
    if (busy) return;
    var c = readConf();
    if (!c) return;
    var want = desired();
    setBusy(true);

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var present = {};
        (cart.items || []).forEach(function (i) { present[String(i.variant_id)] = true; });
        var add = Object.keys(want.updates)
          .filter(function (id) { return want.updates[id] > 0 && !present[id]; })
          .map(function (id) { return { id: Number(id), quantity: want.updates[id] }; });
        if (!add.length) return null;
        return fetch(root() + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: add })
        }).then(function (r) { if (!r.ok) return r.text().then(function (t) { throw new Error(t); }); return r.json(); });
      })
      .then(function () {
        return fetch(root() + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: want.updates, attributes: want.attributes, sections: sectionIds() })
        }).then(function (r) { if (!r.ok) return r.text().then(function (t) { throw new Error(t); }); return r.json(); });
      })
      .then(function (data) {
        swap(data && data.sections);
        return syncProps().then(function () {
          setBusy(false);
          scheduleRefresh();
          return load(true);
        });
      })
      .catch(function (err) {
        setBusy(false);
        log('push failed', err && err.message);
        var n = (attempt || 0) + 1;
        if (n < 3) { setTimeout(function () { push(n); }, 400 * n); return; }
        panels().forEach(function (p) {
          var note = p.querySelector('[data-cc-note]');
          if (note) note.textContent = 'We could not update your basket just now. Please try again.';
        });
      });
  }

  function swap(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var html = sections[key];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.getElementById('shopify-section-' + key);
      var dst = document.getElementById('shopify-section-' + key);
      if (src && dst) dst.innerHTML = src.innerHTML;
    });
    mount();
    gate();
  }

  function refreshSections() {
    fetch(location.pathname + '?sections=' + sectionIds().join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) { swap(s); })
      .catch(function () {});
  }

  function scheduleRefresh() { [300, 1300, 2600].forEach(function (ms) { setTimeout(refreshSections, ms); }); }

  /* ---------- drawer mounting ---------- */

  function mountHost() {
    for (var i = 0; i < MOUNTS.length; i++) {
      var el = document.querySelector(MOUNTS[i]);
      if (el) return { el: el, append: i === 0 };
    }
    var btn = document.querySelector('#CartDrawer-Checkout');
    return btn && btn.parentElement ? { el: btn.parentElement, append: false } : null;
  }

  function mount() {
    var host = mountHost();
    var tpl = template();
    if (!host || !tpl) return false;
    if (host.el.querySelector('[data-cc-live]')) return false;

    var clone = tpl.cloneNode(true);
    clone.removeAttribute('hidden');
    clone.setAttribute('data-cc-live', '');
    clone.setAttribute('data-cc-where', 'drawerlive');
    clone.querySelectorAll('[id]').forEach(function (n) { n.id = n.id + '-live'; });
    clone.querySelectorAll('label[for]').forEach(function (n) { n.setAttribute('for', n.getAttribute('for') + '-live'); });

    if (host.append) host.el.appendChild(clone);
    else host.el.insertBefore(clone, host.el.firstChild);

    paint();
    return true;
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (e) {
    var esc = e.target && e.target.closest ? e.target.closest('[data-cc-escape]') : null;
    if (esc) {
      e.preventDefault();
      (esc.getAttribute('data-cc-escape') === 'o' ? S.o : S.b).m = 'self';
      paint();
      push(0);
      return;
    }

    /* Kosz przy NASZEJ linii: nie czekamy na samonaprawe. Zanim 5-sekundowy
       odczyt zauwazy brak, klient zdazylby przejsc do platnosci z koszykiem bez
       dostawy. Dlatego blokujemy checkout w tej samej klatce, a dociagniecie
       linii zostawiamy samonaprawie. */
    var rm = e.target && e.target.closest
      ? e.target.closest('cart-remove-button, a[href*="/cart/change"]') : null;
    if (rm) {
      var rrow = rm.closest ? rm.closest('.cart-item') : null;
      if (rrow && rrow.classList.contains('cc-locked')) { S.synced = false; gate(); }
      setTimeout(function () { if (!busy) load(true); }, 350);
    }

    var t = e.target && e.target.closest ? e.target.closest('[data-cc-tab]') : null;
    if (!t) {
      var inside = e.target && e.target.closest && e.target.closest('[data-cc-dm]');
      if (!inside) setTimeout(function () { if (!busy) load(false); }, 600);
      return;
    }
    e.preventDefault();
    var group = t.getAttribute('data-cc-tab');
    var val = t.getAttribute('data-cc-val');
    (group === 'o' ? S.o : S.b).m = val;
    paint();
    push(0);
  }, true);

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.getAttribute) return;

    if (t.hasAttribute('data-cc-phone')) {
      S.phone = t.value;
      clearTimeout(typing);
      paint();
      typing = setTimeout(function () { push(0); }, 600);
      return;
    }

    var f = t.getAttribute('data-cc-f');
    if (!f) return;
    var parts = f.split(':');
    var leg = parts[0] === 'b' ? S.b : S.o;
    var key = parts[1];
    leg[key] = t.value;
    if (key === 'p') {
      leg.zone = zoneOf(t.value);
      /* Ktos wpisal EH12 9DN recznie — przelaczamy na tryb lotniska, zeby nie
         powstalo zamowienie z cena lotniska, adresem i bez godziny. */
      if (leg.zone === 'airport') leg.air = true;
      leg.check = { state: 'idle' };
      clearTimeout(leg._pcTimer);
      leg._pcTimer = setTimeout(function () { lookup(leg); }, 450);
    }
    clearTimeout(typing);
    paint();
    typing = setTimeout(function () { push(0); }, 600);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;

    if (t.matches('[data-cc-air]')) {
      var leg = t.getAttribute('data-cc-air') === 'b' ? S.b : S.o;
      leg.air = !!t.checked;
      leg.zone = leg.air ? airportZone() : (leg.p ? zoneOf(leg.p) : null);
      if (leg.air) leg.check = { state: 'idle' };
      paint();
      push(0);
      return;
    }

    if (!t.matches('[data-cc-same]')) return;
    S.same = !!t.checked;
    paint();
    push(0);
  }, true);

  function boot() { readConf(); mount(); load(true); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  new MutationObserver(function () { mount(); gate(); })
    .observe(document.documentElement, { childList: true, subtree: true });

  setInterval(function () { if (mount()) paint(); gate(); }, 800);

  /* Cykliczny odczyt koszyka. Klikniecie kosza lapiemy handlerem click, ale to nie
     wystarcza: klient moze miec koszyk otwarty w dwoch kartach i usunac oplate w
     jednej, a zaplacic z drugiej, ktora nic o tym nie wie. Co 5 s porownujemy wiec
     stan z serwerem niezaleznie od tego, co sie dzialo w tej karcie. */
  setInterval(function () {
    if (document.visibilityState === 'hidden') return;
    if (busy) return;
    if (!document.querySelector('[data-cc-dm]')) return;
    load(false);
  }, 5000);
})();
